import { render, staticRenderFns } from "./SheetCardRow.vue?vue&type=template&id=248838e3&scoped=true&"
import script from "./SheetCardRow.vue?vue&type=script&lang=js&"
export * from "./SheetCardRow.vue?vue&type=script&lang=js&"
import style0 from "./SheetCardRow.vue?vue&type=style&index=0&id=248838e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248838e3",
  null
  
)

export default component.exports